<template lang="pug">
    section#page(ref="page")
        faelPlus(:class="{ ativo: ativo == 'faelPlus' }")
        faelflix(:class="{ ativo: ativo == 'faelflix' }")
        .wrapper(v-if="ativo != 'faelflix'")
            div.inscrevase
                button(:class="{'faelflix': ativo == 'faelflix', 'faelPlus': ativo == 'faelPlus'}" @click="$parent.goTo('#formulario')") Inscreva-se
</template>

<script>
import faelPlus from '@components/FaelPlus/FaelPlus.vue'
import faelflix from '@components/Faelflix/Faelflix.vue'

export default {
    name: "page",
    components: {
        faelPlus,
        faelflix,
    },
    data() {
        return {
            ativo: null,
        }
    },
    mounted() {
        // if(window.innerWidth > 1024)
        //     window.addEventListener('scroll', this.moveImages)
        this.$eventBus.$on('experienciaFael', section => this.ativo = section)
    },
    methods: {
        // moveImages() {
        //     if (window.scrollY + window.innerHeight > this.$refs.page.offsetHeight && this.ativo) {
        //         let images = document.querySelectorAll(`#${this.ativo} .img`)
        //         images.forEach((image) => {
        //             image.style.transform = `translateY(-${window.scrollY / 40}px)`
        //         })
        //     }
        // }
    },
}
</script>

<style lang="stylus" scoped src="./Page.styl"></style>